<template>
  <div id="app">
      <router-view></router-view>
  </div>
</template>

<style lang='less'>
    @import './assets/less/common.less';
</style>

<script>
  export default {
    name: "app"
  }
</script>



// WEBPACK FOOTER //
// src/App.vue